"use client";

import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { Progress } from "@/components/ui/progress";
import { useCart } from "@/queries/useCart";
export function FreeShippingTracker() {
  const $ = _c(10);
  const {
    data: cart
  } = useCart();
  const freeShippingInfo = cart?.freeShippingInfo;
  if (!freeShippingInfo) {
    return null;
  }
  let t0;
  if ($[0] !== freeShippingInfo.freeShippingPriceDistance) {
    t0 = CurrencyFormatter.formatUSD(freeShippingInfo.freeShippingPriceDistance);
    $[0] = freeShippingInfo.freeShippingPriceDistance;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="font-bold"> free shipping!</span>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <p className="text-center text-sm">Add {t0} to get{t1}</p>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== freeShippingInfo.freeShippingPricePercentage) {
    t3 = <Progress value={freeShippingInfo.freeShippingPricePercentage} />;
    $[5] = freeShippingInfo.freeShippingPricePercentage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex w-full flex-col gap-1 px-6">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}